import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-magento-dev',
  templateUrl: './custom-magento-dev.component.html',
  styleUrls: ['./custom-magento-dev.component.css']
})
export class CustomMagentoDevComponent implements OnInit {

  constructor(private CommonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.CommonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/custom-magento-dev/custom-magento-dev.component.ts